import { jsx as t } from "react/jsx-runtime";
import { f as l, M as s, N as a } from "../../vendor--aJiswR_.js";
import { forwardRef as n } from "react";
import { stupidInvertClasses as p } from "../../utils/index.js";
import { ChildFilter as d } from "../../utils/ChildFilter/index.js";
import '../../assets/index29.css';const m = "_tooltip_cxmic_1", f = {
  tooltip: m
}, h = n(
  ({ placement: o = "top", __inverted: i, children: e }, r) => {
    const c = l(f.tooltip, i ? p() : void 0);
    return /* @__PURE__ */ t(s, { ref: r, placement: o, className: c, "data-component": "Tooltip", children: /* @__PURE__ */ t(d, { invalidChildren: ["a", "button", "iconbutton", "link"], children: e }) });
  }
), v = (o) => a({ ...o, delay: o.delay === "immediate" ? 0 : 300, closeDelay: 0 });
export {
  h as Tooltip,
  v as TooltipTrigger
};
//# sourceMappingURL=index.js.map
